/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  InputBox,
  SearchBox,
  SearchBoxRow,
  SearchButtonWrap,
  SearchCols,
  SearchRows,
} from '../../components/layouts/SearchBox';
import { CustomInputText, CustomInputWrap } from '../../components/inputs/CustomInput';
import { Button } from '@mui/material';
import { ContentSection } from '../../components/layouts/ContentSection';
import RoleManagementGrid from './rolemanagement/RoleManagementGrid';
import { IconButton } from '../../components/buttons/IconSVG';
import CustomInputWithSearch from 'components/inputs/CustomInputWithSearch';
import { ComboBox } from '../../components/selects/ComboBox';
import { Code } from '../../models/common/CommonCode';
import { getCommonCodeNames } from '../../apis/admin/CommonCode';
const RoleManagementPage: React.FC = () => {
  const { t } = useTranslation();

  const [searchParam, setSearchParam] = useState<string>('');
  const [textboxData, setTextboxData] = useState<string>('');
  const [authGrnYn, setAuthGrnYn] = useState<string>('');
  const [fuseYn, setfUseYn] = useState<string>('');
  const [getUseYn, setUseYn] = useState<Code[]>([]);

  useEffect(() => {
    initComboBoxCondition();
  }, []);

  const initComboBoxCondition = async () => {
    //사용여부
    const getUseYn: Code[] = await getCommonCodeNames('YN_FLAG');
    setUseYn(getUseYn);
  };

  const handleSearchParamData = (e: any) => {
    setTextboxData(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      btnSearch();
    }
  };

  const handleResetCondition = () => {
    setTextboxData('');
    setAuthGrnYn('');
    setfUseYn('');
  };

  const btnSearch = () => {
    setSearchParam(textboxData);
  };

  return (
    <>
      <SearchBox>
        <SearchBoxRow>
          <InputBox>
            <SearchRows>
              <SearchCols>
                <label>{t('admin.label.역할명', '역할명')}</label>
                <CustomInputWithSearch
                  value={textboxData}
                  onChange={handleSearchParamData}
                  onKeyDown={handleKeyDown}
                  placeholder={String(
                    t('admin.label.역할명을 입력해 주세요.', '역할명을 입력해 주세요.')
                  )}
                />
              </SearchCols>
              <SearchCols>
                <label>{t('admin.label.ELM권한여부', 'ELM권한여부')}</label>
                <ComboBox
                  placeholder={String(t('asst.msg.선택', '선택'))}
                  options={getUseYn || []}
                  onChange={(value) => setAuthGrnYn(value)}
                />
              </SearchCols>
              <SearchCols>
                <label>{t('admin.label.사용여부', '사용여부')}</label>
                <ComboBox
                  placeholder={String(t('asst.msg.선택', '선택'))}
                  options={getUseYn || []}
                  //defaultValue={condition?.rvwRltDivsCd}
                  //onChange={(value) => handleConditionChange('rvwRltDivsCd', value)}
                  onChange={(value) => setfUseYn(value)}
                />
              </SearchCols>
            </SearchRows>
          </InputBox>
          <SearchButtonWrap>
            <Button
              css={IconButton.button}
              className="reload"
              onClick={handleResetCondition}
              disableRipple
            />
            <Button css={IconButton.button} className="find" disableRipple onClick={btnSearch}>
              {t('com.button.조회', '조회')}
            </Button>
          </SearchButtonWrap>
        </SearchBoxRow>
      </SearchBox>
      <RoleManagementGrid
        sRoleNm={searchParam}
        fuseYn={fuseYn}
        sAuthGrnY={authGrnYn}
        editable={true}
      />
    </>
  );
};

export default RoleManagementPage;
